export const AREA_LAYER = 'area';
export const ARC_LAYER = 'arc';
export const LINE_LAYER = 'line';
export const TEXT_LAYER = 'text';
export const POINT_LAYER = 'point';
export const BAR_LAYER = 'bar';
export const TICK_LAYER = 'tick';
export const SIMPLE_LAYER = 'simple';
export const BASE_LAYER = 'base';
